(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aa-project-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-aa-archive]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const cards = [...root.querySelectorAll('[data-project]')];
  const filters = [...root.querySelectorAll('[data-category-filter]')];
  const status = root.querySelector('[data-project-count]');
  const controls = root.querySelector('[data-archive-controls]');
  const dialog = root.querySelector('dialog');
  let currentCard = null;
  let opener = null;
  let oldOverflow = '';
  if (controls) controls.hidden = false;
  filters.forEach(button => {
    button.addEventListener('click', () => {
      const category = button.dataset.categoryFilter;
      filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
      cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.category !== category; });
      status.textContent = cards.filter(card => !card.hidden).length + ' ' + status.dataset.label;
    });
  });
  if (!dialog || typeof dialog.showModal !== 'function') return;
  function renderCard(card) {
    currentCard = card;
    const image = card.querySelector('img');
    const link = card.querySelector('[data-open-project]');
    const largeImage = dialog.querySelector('[data-dialog-image]');
    largeImage.src = link.href;
    largeImage.alt = image.alt;
    dialog.querySelector('[data-dialog-title]').textContent = card.dataset.title;
    dialog.querySelector('[data-dialog-category]').textContent = card.dataset.categoryLabel;
    dialog.querySelector('[data-dialog-description]').textContent = card.dataset.description;
    const visible = cards.filter(item => !item.hidden);
    dialog.querySelector('[data-dialog-position]').textContent = (visible.indexOf(card) + 1) + ' / ' + visible.length;
  }
  cards.forEach(card => {
    card.querySelector('[data-open-project]').addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      opener = event.currentTarget;
      renderCard(card);
      oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    });
  });
  function step(direction) {
    const visible = cards.filter(card => !card.hidden);
    const index = visible.indexOf(currentCard);
    renderCard(visible[(index + direction + visible.length) % visible.length]);
  }
  dialog.querySelector('[data-previous-project]').addEventListener('click', () => step(-1));
  dialog.querySelector('[data-next-project]').addEventListener('click', () => step(1));
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      step(event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = oldOverflow;
    opener?.focus();
    dialog.querySelector('[data-dialog-image]').removeAttribute('src');
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-sneaker-sizing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-size-choice')) {
    customElements.define('aa-size-choice', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        if (!this.root) return;
        this.chosen = false;
        this.onChange = (event) => {
          const field = event.target.closest('[data-aa-size-option]');
          if (!field || !this.root.contains(field)) return;
          if (!event.target.matches('input, select')) return;
          if (!event.target.value) return;
          this.chosen = true;
          this.querySelector('[data-aa-size-prompt]').hidden = true;
          this.root.querySelectorAll('[data-add-to-cart]').forEach((button) => { button.disabled = true; });
        };
        this.onSubmit = (event) => {
          if (this.chosen || !event.target.matches('[data-product-form]')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const field = this.root.querySelector('[data-aa-size-option]');
          field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          field?.querySelector('input[type="radio"], [data-popout-toggle], select')?.focus();
        };
        this.root.addEventListener('change', this.onChange, true);
        this.root.addEventListener('submit', this.onSubmit, true);
        this.observer = new MutationObserver(() => this.enforceChoice());
        this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
        this.enforceChoice();
      }

      enforceChoice() {
        if (this.chosen) return;
        const field = this.root.querySelector('[data-aa-size-option]');
        if (!field) return;
        const prompt = this.dataset.prompt;
        field.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = false;
          input.removeAttribute('checked');
        });
        field.querySelectorAll('[data-popout-input]').forEach((input) => {
          input.value = '';
          input.dataset.optionValueId = '';
        });
        field.querySelectorAll('[aria-current], [selected]').forEach((option) => {
          option.removeAttribute('aria-current');
          option.removeAttribute('selected');
        });
        field.querySelectorAll('[data-selected-value], [data-popout-toggle-text]').forEach((label) => {
          if (label.textContent !== prompt) label.textContent = prompt;
        });
        this.root.querySelectorAll('[data-add-to-cart]').forEach((button) => {
          if (!button.disabled) button.disabled = true;
          const label = button.querySelector('[data-add-to-cart-text]');
          if (label && label.textContent !== prompt) label.textContent = prompt;
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.root?.removeEventListener('change', this.onChange, true);
        this.root?.removeEventListener('submit', this.onSubmit, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
